import { RuleCheckItem, FieldConfig } from './types';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

export const getErrorMessage = (field: FieldConfig, validationResultObject?: RuleCheckItem | boolean) => {
  if (validationResultObject && validationResultObject instanceof Object) {
    return t(validationResultObject.errorMessage, validationResultObject.params);
  }

  if (field.errorMessage) {
    if (field.messageParams) {
      return t(field.errorMessage, { ...field.messageParams });
    }
    return t(field.errorMessage);
  }
};
